// Modules
import { createContext } from 'react'

// Context: Data
const Data = createContext()

// Export
export default Data
